<template>
	<div class="submission-overlay" @click.self="close">
		<div class="scene">
			<div class="card" :class="{ 'is-flipped': isFlipped }">
				<div class="card__face card__face--front" @click="flipCard">
					<span
						class="absolute top-0 right-0 p-4"
						@click="close"
					>
						<CloseIcon />
					</span>
					<div class="card-text flex-grow flex items-center">
						<div class="w-full">
							{{
								user_name(
									submission.pick_data.room_user_id
								)
							}}'s Submission
						</div>
					</div>
					<div class="text-xs text-gray-400 flex-grow-0">
						Click to flip
					</div>
				</div>
				<div class="card__face card__face--back" @click="flipCard">
					<span
						class="absolute top-0 right-0 p-4"
						@click="close"
					>
						<CloseIcon />
					</span>
					<div class="card-text flex-grow flex items-center">
						<div class="w-full">
							{{
								user_name(
									submission.pick_data.room_user_id
								)
							}}
							wants to pick
							{{
								player_name(
									submission.pick_data.player_id
								)
							}}
						</div>
					</div>
					<div class="card-actions flex">
						<div class="flex-grow w-1/2">
							<button
								class="base-btn bg-red-600 hover:bg-red-900 w-3/4"
								@click="reject"
							>
								Reject
							</button>
						</div>
						<div class="flex-grow w-1/2">
							<button
								class="base-btn bg-blue-600 hover:bg-blue-900 w-3/4"
								@click="confirm"
							>
								Confirm
							</button>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<style lang="scss">
.submission-overlay {
	@apply absolute top-0 left-0 min-h-screen min-w-full bg-gray-300 py-6 flex flex-col justify-center z-10 sm:py-12;
	background: rgba(0, 0, 0, 0.73);
}

.scene {
	@apply py-3 sm:max-w-xl sm:mx-auto;
	width: 360px;
	height: 300px;
	perspective: 600px;
}

.card {
	@apply relative w-full h-full cursor-pointer;
	transform-style: preserve-3d;
	transform-origin: center right;
	transition: transform 1s;
}

.card.is-flipped {
	transform: translateX(-100%) rotateY(-180deg);
}

.card__face {
	@apply absolute w-full h-full shadow p-4 bg-white flex flex-col text-center justify-center;
	backface-visibility: hidden;
}

.card__face--front {
}

.card__face--back {
	transform: rotateY(180deg);
}

.card-actions {
	@apply flex;
}
</style>

<script>
import { mapGetters } from 'vuex';
import CloseIcon from '@/components/common/CloseIcon';

export default {
	components: {
		CloseIcon,
	},
	computed: {
		...mapGetters(['user_name', 'player_name']),
	},
	props: {
		submission: Object,
		confirm: Function,
		reject: Function,
		close: Function,
	},
	data() {
		return {
			isFlipped: false,
		};
	},
	methods: {
		flipCard() {
			this.isFlipped = !this.isFlipped;
		},
	},
};
</script>
